import React from 'react';
import { NavbarHelixIcon } from './NavbarHelixIcon.js';
import { useFocusManager } from '@react-aria/focus';

const NavbarMobileMenuToggleButton = React.forwardRef(({ menuOpen, setMenuOpen }, ref) => {
    // eslint-disable-next-line react-hooks/rules-of-hooks
    const focusManager = useFocusManager();
    const handleKeyDown = (e) => {
        if (!focusManager)
            return;
        switch (e.key) {
            case 'ArrowDown':
                e.preventDefault();
                focusManager.focusNext({ wrap: true });
                break;
            case 'ArrowUp':
                e.preventDefault();
                focusManager.focusPrevious({ wrap: true });
                break;
            case 'End':
                e.preventDefault();
                focusManager.focusLast({});
                break;
            case 'Home':
                e.preventDefault();
                focusManager.focusFirst({});
                break;
        }
    };
    return (React.createElement("button", { ref: ref, "aria-label": menuOpen ? 'Close menu' : 'Open menu', className: `helix-unified-nav__navigation-item helix-unified-nav__mobile-menu-trigger ${menuOpen ? 'active' : ''}`, onKeyDown: (e) => handleKeyDown(e), onClick: () => {
            setMenuOpen();
        } },
        React.createElement(NavbarHelixIcon, { iconName: menuOpen ? 'close' : 'menu' })));
});
NavbarMobileMenuToggleButton.displayName = 'NavbarMobileMenuToggleButton';

export { NavbarMobileMenuToggleButton as default };
//# sourceMappingURL=NavbarMobileMenuToggleButton.js.map
